import { TabContext, TabList, TabPanel } from "@mui/lab";
import Tab from "@mui/material/Tab";
import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";

function ListCreateTab({
  mod,
  viewIcon,
  createIcon,
  listChildren,
  createChildren,
}) {
  const [value, setValue] = useState("list");
  const [width, setWidth] = useState(320);
  const parentRef = useRef();
  const theme = useTheme();

  useEffect(() => {
    const resizeObserver = new ResizeObserver((event) => {
      setWidth(event[0].contentBoxSize[0].inlineSize);
    });
    if (parentRef) {
      resizeObserver.observe(parentRef.current);
    }
  }, [parentRef]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box ref={parentRef} sx={{ flexGrow: 1, width: "100%" }}>
      <TabContext value={value}>
        <Box
          sx={{
            width: { width },
            borderBottom: 1,
            borderColor: "divider",
            position: "fixed",
            zIndex: 10,
            flexGrow: 1,
            backgroundColor: "background.paper",
            borderTopRightRadius: theme.shape.borderRadius,
            WebkitBorderTopLeftRadius: theme.shape.borderRadius,
          }}
        >
          <TabList variant="fullWidth" onChange={handleChange}>
            <Tab
              icon={viewIcon}
              iconPosition="start"
              label={`View ${mod}`}
              value="list"
            />
            <Tab
              icon={createIcon}
              iconPosition="start"
              label={`Create ${mod}`}
              value="create"
              sx={{ minWidth: "fit-content", flex: 1 }}
            />
          </TabList>
        </Box>

        <Box marginTop="48px">
          <TabPanel value="list">{listChildren}</TabPanel>
          <TabPanel value="create">{createChildren}</TabPanel>
        </Box>
      </TabContext>
    </Box>
  );
}

export default ListCreateTab;
